import React from 'react'
import EssLayout from '../../../../layout/components/ESSLayout'
import ESSPunchList from '../../EssAttendance/components/ESSPunchList'
import EssAttendance from '../../EssAttendance/components/EssAttendance'
import ESSLeaveRequest from '../../EssAttendance/components/ESSLeaveRequest'

function EssDashboardPage() {
  return (
    <EssLayout>
        <div className='container-fluid'>
            <div className='row'>
                
                <div className='col-md-6'>
                    <EssAttendance />
                </div>
                <div className='col-md-6'>
                  <ESSPunchList />
                </div>
                <div className='col-md-6'>
                  
                </div>
            </div>
        </div>
    </EssLayout>
  )
}

export default EssDashboardPage